import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CancellationPolicyLayer from "../components/CancellationPolicyLayer";

const CancellationPolicyPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Cancellation Policy" />


        {/* TermsConditionLayer */}
        <CancellationPolicyLayer />

      </MasterLayout>

    </>
  );
};

export default CancellationPolicyPage; 
